<template>
  <filter-wrapper :initial-open="initialOpen" :title="title">
    <input
      v-if="searchable && hasManyItems"
      v-model="currentSearchValue"
      :placeholder="t.search"
      type="text"
      class="form-control"
    />
    <div :class="{ scrollable: scroll && isExpanded }">
      <filter-item
        :class="itemClasses"
        :key="`filter-item-${index}`"
        v-for="(item, index) in visibleItems"
        v-bind="item"
      ></filter-item>
    </div>
    <button
      v-if="hasManyItems"
      @click="isExpanded = !isExpanded"
      class="btn btn-sm btn-primary-link mt-1 px-0 py-0"
    >
      {{ isExpanded ? t.show_less : t.show_more }}
    </button>
  </filter-wrapper>
</template>

<script>
import FilterItem from "./FilterItem";
import FilterWrapper from "./FilterWrapper";

export default {
  name: "FilterGroup",
  components: {
    FilterItem,
    FilterWrapper,
  },
  props: {
    itemClasses: {
      type: String,
      default: "",
    },
    items: {
      required: true,
      type: Array,
    },
    t: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    maxVisible: {
      type: Number,
      default: 10,
    },
    initialOpen: {
      type: Boolean,
      default: true,
    },
    scroll: {
      type: Boolean,
      default: true,
    },
    searchable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isExpanded: false,
      hasManyItems: this.items.length > this.maxVisible,
      currentSearchValue: "",
    };
  },
  computed: {
    visibleItems() {
      return this.items
        .filter(item => item.name.toLowerCase().includes(this.currentSearchValue.toLowerCase()))
        .slice(0, this.isExpanded ? this.items.length : this.maxVisible);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

$scrollable-area-max-height: 650px;

.scrollable {
  max-height: $scrollable-area-max-height;
  overflow-y: auto;
  overflow-x: hidden;
  margin-left: -$spacer-2;
  margin-right: -$spacer-2;
  padding: 0 $spacer-2;

  &::-webkit-scrollbar {
    width: $scrollbar-width;
  }

  &::-webkit-scrollbar-thumb {
    background: $scrollbar-color;
    border-radius: $scrollbar-width;
  }
}
</style>
